module.exports = __webpack_public_path__ + "static/media/envase3.d19f7b54.jpg";